import axios from "axios";
import { tokenController } from "./tokenController";
import { api } from "./environment";

const http = axios.create({
  baseURL: api.API_URL,
  transformResponse: [
    (data, _, status) => {
      try {
        if (status >= 200 && status < 300) {
          const json = JSON.parse(data).result;
          return json;
        }

        return JSON.parse(data);
      } catch {
        return data;
      }
    },
  ],
});

http.interceptors.request.use(
  (config) => {
    const token = tokenController.getToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

export default http;
